import * as URLS from '@src/constants/URLS.const';
import { PermissionKeys } from '@src/typings/permissionKeys.d';

export const sidebarKeys = {
    [PermissionKeys.Store]: {
        URL: URLS.DASHBOARD_URL,
        key: 'store',
    },
    [PermissionKeys.Orders]: {
        URL: `${URLS.DASHBOARD_URL}/${URLS.ORDERS_BASE_URL}`,
        key: 'orders',
        icon: 'shopping-cart',
    },
    [PermissionKeys.SimManagement]: {
        URL: `${URLS.DASHBOARD_URL}/${URLS.SIM_MANAGEMENT_BASE_URL}`,
        key: 'sim-management',
        icon: 'sim-card',
    },
    [PermissionKeys.Referral]: {
        URL: `${URLS.DASHBOARD_URL}/${URLS.REFERRAL_BASE_URL}`,
        key: 'referral',
        icon: 'referral',
    },
    ['divider']: {
        type: 'divider',
    },
    [PermissionKeys.Profile]: {
        URL: `${URLS.DASHBOARD_URL}/${URLS.PROFILE_BASE_URL}`,
        key: 'profile',
        icon: 'user',
    },
    ['divider2']: {
        type: 'divider',
    },
};
